// Un cambio de precio o descripción no debe enviar el saldo cargado en el formulario.
export function prepararStockEdicion(formulario) {
  const payload = { ...formulario };
  delete payload.stock_original;
  if (formulario.id) {
    if (Number(formulario.cantidad_stock) === Number(formulario.stock_original)) {
      delete payload.cantidad_stock;
    } else {
      payload.stock_esperado = formulario.stock_original;
    }
  }
  return payload;
}
